export interface IInsuranceSelected {
  data: IInsurance[],
  insurance: IInsuranceDic | undefined
}

export interface IInsurance {
  cost: number;
  insurance: string;
  plazo: string;
  better?: boolean;
}

export interface IInsuranceRequest {
  idState: number;   // de select de estados
  cpTip: number | string;  // de select de estados
  idTip: number;  // de datos de carro
  year: number;   // de datos del carro
  priceWithIva: number;  // de datos del carro
  insurance: InsurancesEnum;  // enum
  quoterType: string;
  flowType: string;
  version: string;
  userId: string;
  idLeasetech: number;
}
export interface IInsuranceRequestCredit {
  idState: number;   // de select de estados
  cpTip: number | string;  // de select de estados
  idTip: number;  // de datos de carro
  year: number;   // de datos del carro
  priceWithIva: number;  // de datos del carro
  insurance: InsurancesEnum;  // enum
  quoterType: string;
}

export interface IInsuranceDic {
  key: string;
  value: InsurancesEnum
}


export enum InsurancesEnum {
  ATLAS = 1,
  QUALITAS = 3,
  CHUBB = 5,
  GNP = 6,
  NONE = -1,
  TOCONFIRM = -2,
}


export const InsurancesDic = [
  { key: "ATLAS", value: InsurancesEnum.ATLAS, },
  { key: "GNP", value: InsurancesEnum.GNP, },
  { key: "QUALITAS", value: InsurancesEnum.QUALITAS, },
  { key: "CHUBB", value: InsurancesEnum.CHUBB, },
  { key: "NONE", value: InsurancesEnum.NONE, },
  { key: "Por confirmar"  ,value: InsurancesEnum.TOCONFIRM,  },
]



